import React, { useState } from 'react'
import { useSearch } from "../../hooks/SearchContext";
import { IoSearchSharp } from "react-icons/io5";
import { MdLocationOn } from "react-icons/md";
import { useNavigate } from 'react-router-dom';

const Search = () => {

    const { search, setSearch } = useSearch();
    const navigate = useNavigate()

    const jobSuggestions = [
        "Software Engineer",
        "Frontend Developer",
        "Backend Developer",
        "Full Stack Developer",
        "Data Analyst",
        "Project Manager"
    ];

    const locationSuggestions = [
        "New York",
        "San Francisco",
        "Los Angeles",
        "Sydney",
        "London",
        "Berlin"
    ];

    const [filteredJobs, setFilteredJobs] = useState([]);
    const [filteredLocations, setFilteredLocations] = useState([]);

    const handleJobChange = (e) => {
        const value = e.target.value;
        const jobList = value.split(',').map(job => job.trim());
        setSearch({ ...search, jobTitle: value });

        const lastWord = jobList[jobList.length - 1];

        if (lastWord.length > 0) {
            const filtered = jobSuggestions.filter(job =>
                job.toLowerCase().includes(lastWord.toLowerCase())
            );
            setFilteredJobs(filtered);
        } else {
            setFilteredJobs([]);
        }
    };

    const handleLocationChange = (e) => {
        const value = e.target.value;
        setSearch({ ...search, location: value });

        if (value.length > 0) {
            const filtered = locationSuggestions.filter(loc =>
                loc.toLowerCase().includes(value.toLowerCase())
            );
            setFilteredLocations(filtered);
        } else {
            setFilteredLocations([]);
        }
    };

    const selectJob = (job) => {
        const jobList = search.jobTitle.split(',').map(j => j.trim());
        jobList[jobList.length - 1] = job; // Replace last word with selected job
        setSearch({ ...search, jobTitle: jobList.join(', ') + ', ' });
        setFilteredJobs([]);
    };

    const selectLocation = (loc) => {
        setSearch({ ...search, location: loc });
        setFilteredLocations([]);
    };

    return (
        <div className='w-full flex flex-col items-center max-w-[800px] mx-auto relative'>
            <div className='w-full flex gap-2 items-center pl-4 py-[6px] bg-white shadow border-none rounded-md text-sm relative'>

                {/* Search Icon */}
                <IoSearchSharp className="text-2xl text-[var(--primary)]" />

                {/* Job Role Input */}
                <div className='relative w-1/2'>
                    <input
                        className="border-none outline-none w-full"
                        placeholder="Enter Job Role / Keyword / Category"
                        value={search.jobTitle}
                        onChange={handleJobChange}
                    />
                    {/* Dropdown for Job Roles */}
                    {filteredJobs.length > 0 && (
                        <ul className="absolute top-full left-[-35px] right-1 bg-white shadow-md rounded-md mt-1 z-10">
                            {filteredJobs.map((job, index) => (
                                <li key={index} className="px-3 py-2 flex items-center gap-2 cursor-pointer hover:bg-[#E6F7FF]"
                                    onClick={() => selectJob(job)}>
                                    <IoSearchSharp className="text-gray-500" />
                                    {job}
                                </li>
                            ))}
                        </ul>
                    )}
                </div>

                {/* Location Icon */}
                <MdLocationOn className="text-2xl text-[var(--primary)]" />

                {/* Location Input */}
                <div className='relative w-1/2'>
                    <input
                        className="border-none outline-none w-full"
                        placeholder="Enter Location"
                        value={search.location}
                        onChange={handleLocationChange}
                    />
                    {/* Dropdown for Locations */}
                    {filteredLocations.length > 0 && (
                        <ul className="absolute top-full left-[-36px] right-0 bg-white shadow-md rounded-md mt-1 z-10">
                            {filteredLocations.map((loc, index) => (
                                <li key={index} className="px-3 py-2 flex items-center gap-2 cursor-pointer hover:bg-[#E6F7FF]"
                                    onClick={() => selectLocation(loc)}>
                                    <MdLocationOn className="text-gray-500" />
                                    {loc}
                                </li>
                            ))}
                        </ul>
                    )}
                </div>

                {/* Search Button */}
                <button className='button !rounded-md flex items-center justify-center w-[100px] mr-1'
                    onClick={() => navigate('/jobs')}>
                    Search
                </button>
            </div>
        </div>
    )
}

export default Search